import { FaClipboardList, FaCloudDownloadAlt, FaFileAlt } from "react-icons/fa";
import { FaMapLocationDot } from "react-icons/fa6";
import { MdAccessTime, MdLocationOff } from "react-icons/md";

export const msOData = [
    {
      title: "IP Restriction",
      video: true,
      videoId: "5r_FvYxoPEk",
      videoType: "youtube",
      icon: <MdLocationOff className='text-white fs-5' />
    },
    {
      title: "Clipboard Restriction",
      video: true,
      videoId: "7Km9prck5WY",
      videoType: "youtube",
      icon: <FaClipboardList className='text-white fs-5' />
    },
    {
      title: "Download Restriction",
      video: true,
      videoId: "5AEv7V2nAFI",
      videoType: "youtube",
      icon: <FaCloudDownloadAlt className='text-white fs-5' />
    },
    {
      title: "Time-based Restriction",
      video: true,
      videoId: "d_3Ho_Cv_JE",
      videoType: "youtube",
      icon: <MdAccessTime className='text-white fs-5' />
    },
    {
      title: "Location-based Restriction",
      video: true,
      videoId: "Mtc9M0Bf-zM",
      videoType: "youtube",
      icon: <FaMapLocationDot className='text-white fs-5' />
    },
    {
      title: "Session file Restriction",
      video: true,
      videoId: "vDPK8-RcON4",
      videoType: "youtube",
      icon: <FaFileAlt className='text-white fs-5' />
    }
  ]